/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetThreadedP2pPaymentStatsInternalRequest} from '@cash-web/protos/squareup/cash/activity/api/v1/search.pb'
import {GetThreadedP2pPaymentStatsInternalResponse} from '@cash-web/protos/squareup/cash/activity/api/v1/search.pb'


export const getThreadedP2pPaymentStatsInternal = (request: GetThreadedP2pPaymentStatsInternalRequest, options?: CashRequestOptions) => post<GetThreadedP2pPaymentStatsInternalRequest, GetThreadedP2pPaymentStatsInternalResponse>("/2.0/cash/get-threaded-p2p-payment-stats-internal", request, {...options, rejectOnError: true })